import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useUpdate } from "@/hooks/queries";

import OrganizationForm from "../OrganizationForm";

export const OrganizationEdit = ({ model }) => {
  const { t } = useTranslation();

  const { id, name, description, address, default_template } = model;
  const mutation = useUpdate("organizations", id);
  const saveButtonLabel = t("global:update");
  const initialValues = {
    name,
    description,
    address,
    template: default_template,
  };

  return (
    <OrganizationForm
      model={model}
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
    />
  );
};

OrganizationEdit.propTypes = {
  model: PropTypes.object.isRequired,
};
